import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControlErrorsComponent } from './form-control-errors.component';
import { FormControlErrorsDirective } from './form-control-errors.directive';
import { FormControlErrorsContainerDirective } from './form-control-errors-container.directive';
import { FormSubmitDirective } from './form-submit.directive';

@NgModule({
    declarations: [
        FormControlErrorsComponent,
        FormControlErrorsDirective,
        FormControlErrorsContainerDirective,
        FormSubmitDirective
    ],
    exports: [
        FormControlErrorsComponent,
        FormControlErrorsDirective,
        FormControlErrorsContainerDirective,
        FormSubmitDirective
    ],
    imports: [
        CommonModule
    ]
})
export class FormControlErrorsModule {
}
